module.exports = __webpack_public_path__ + "media/images/setting-nav-icon-hover-8857a0e53d31c3c37e71078269137a54.svg";